<template>
  <!-- 物料品牌 -->
  <div class="wrapper">
    <div class="searchconditions">
      <el-form :model="listForm" ref="listForm" inline>
        <el-form-item prop="productBrandName" label="品牌名称">
          <el-input
            v-model="listForm.productBrandName"
            placeholder="请输入名称"
            maxlength="50"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="cyan" @click="searchList"
            >查询</el-button
          >
          <el-button icon="el-icon-refresh" type="warning" @click="reset"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <el-row :gutter="10">
      <el-col :span="1.5" class="add-btn">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd"
          >新增</el-button
        >
      </el-col>
    </el-row>
    <el-table :data="list" v-loading="loading" border>
      <el-table-column
        type="index"
        label="序号"
        width="80"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="productBrandName"
        label="品牌名称"
        min-width="120"
        align="center"
      >
        <!-- <template slot-scope="scope">
          <span
            style="cursor: pointer; color: #409eff"
            @click="rowDetail(scope.row)"
            >{{ scope.row.productBrandName }}</span
          >
        </template> -->
      </el-table-column>
      <el-table-column
        prop="productBrandCode"
        label="品牌编号"
        align="center"
        min-width="100"
      ></el-table-column>
      <el-table-column label="公众号二维码" align="center" min-width="100">
        <template slot-scope="scope">
          <el-image
            style="width: auto; height: 80px"
            class="temp-img"
            :src="scope.row.productBrandQrCode"
            :preview-src-list="[scope.row.productBrandQrCode]"
          >
          </el-image>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="status"
        label="状态"
        align="center"
        min-width="100"
      >
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            active-color="#13ce66"
            :active-value="0"
            :inactive-value="1"
            @change="statusChange(scope.row)"
          ></el-switch>
        </template>
      </el-table-column> -->
      <el-table-column
        label="操作"
        align="center"
        min-width="150"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            icon="el-icon-edit"
            @click="handleEdit(scope.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next, sizes, total, jumper"
      :page-sizes="[10, 15, 20]"
      :page-size="listForm.pageSize"
      :total="total"
      :current-page="listForm.pageNum"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    >
    </el-pagination>
    <el-dialog
      :title="title"
      :visible.sync="dialogBrand"
      :close-on-click-modal="false"
      width="800px"
      @close="dialogBrandClose"
    >
      <el-form
        ref="editForm"
        :model="editForm"
        label-width="125px"
      >
        <el-row>
          <el-col :span="16">
            <el-form-item label="品牌名称" prop="productBrandName">
              <el-input
                disabled
                v-model="editForm.productBrandName"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="16">
            <el-form-item label="品牌编号" prop="productBrandCode">
              <el-input
                disabled
                v-model="editForm.productBrandCode"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="16">
            <el-form-item label="品牌公众号" prop="productBrandQrCode">
              <el-upload
                class="avatar-uploader"
                action=""
                :show-file-list="false"
                :http-request="uploadFile"
                :on-success="handleUploadSuccess"
                :on-error="handleUploadError"
                :before-upload="beforeUpload"
              >
                <img
                  v-if="editForm.productBrandQrCode"
                  :src="editForm.productBrandQrCode"
                  class="avatar"
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogBrand = false">取 消</el-button>
        <el-button type="primary" @click="saveAddOrEdit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getBrandPageList,
  addOrUpdateBrand,
  uploadImage,
} from "@/common/api.js";
export default {
  props: {},
  data() {
    return {
      loading: false,
      listForm: {
        pageNum: 1,
        pageSize: 10,
        status: null,
        productBrandName: "",
      },
      total: 0,
      list: [],
      title: "新增品牌",
      dialogBrand: false,
      editForm: {
        id: "",
        productBrandName: "", //名称
        productBrandCode: "", //编号
        productBrandQrCode: "", //公众号图片
      },
      // editRule: {
        // productBrandName: [
        //   { required: true, message: "请输入品牌名称", trigger: "blur" },
        // ],
        // productBrandCode: [
        //   { required: true, message: "请输入品牌编号", trigger: "blur" },
        // ],
        // productBrandQrCode: [
        //   { required: true, message: "请上传公众号图片", trigger: "change" },
        // ],
      // },
    };
  },
  methods: {
    // 物料列表
    getPageList() {
      var params = this.listForm;
      this.loading = true;
      getBrandPageList(params).then((res) => {
        this.loading = false;
        if (res.errorCode == 200) {
          this.list = res.data.list;
          this.total = res.data.total;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 新增品牌
    handleAdd() {
      this.title = "新增品牌";
      this.dialogBrand = true;
    },
    // 保存
    saveAddOrEdit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          var params = this.editForm;
          console.log(this.editForm);
          // return;
          addOrUpdateBrand(params).then((res) => {
            if (res.errorCode == 200) {
              this.$message({
                type: "success",
                message: "保存成功",
              });
              this.dialogBrand = false;
              this.getPageList();
              console.log(res);
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },

    // 上传产品图片
    uploadFile(file) {
      let formDatas = new FormData();
      formDatas.append("businessLicence", file.file);
      uploadImage(formDatas).then((res) => {
        if (res.errorCode == 200) {
          file.onSuccess(res);
        }
      });
    },
    beforeUpload(file) {
      console.log(file.type);
      const isJPG =
        file.type === "image/jpg" ||
        file.type === "image/png" ||
        file.type === "image/jpeg";

      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isJPG) {
        this.$message.error("上传图片仅支持JPG、PNG格式!");
      }
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5MB!");
      }
      return isJPG && isLt5M;
    },
    // 上传成功
    handleUploadSuccess(res, file, fileList) {
      this.editForm.productBrandQrCode = res.url;
    },
    // 上传失败
    handleUploadError(err, file, fileList) {
      this.$message.error(err);
    },
    handleEdit(row) {
      this.dialogBrand = true;
      this.editForm = {
        id: row.id,
        productBrandName: row.productBrandName,
        productBrandCode: row.productBrandCode,
        productBrandQrCode: row.productBrandQrCode,
      };
    },
    //修改状态
    statusChange(row) {
      const h = this.$createElement;
      let text = "";
      if (row.status == 0) {
        text = "启用";
      } else if (row.status == 1) {
        text = "禁用";
      }
      this.$msgbox({
        title: "提示",
        message: h("p", null, [
          h("h3", null, '是否将 "' + text + '" 该品牌?', "警告"),
        ]),
        showCancelButton: true,
        closeOnClickModal:false,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            done();
            var params = {
              id: row.id,
              status: row.status,
            };
            addOrUpdateBrand(params).then((res) => {
              if (res.errorCode == 200) {
                this.$message({
                  type: "success",
                  message: "操作成功",
                });
              } else {
                this.$message.error(res.msg);
                if (row.status == 1) {
                  row.status = 0;
                } else if (row.status == 0) {
                  row.status = 1;
                }
              }
            });
          } else {
            done();
            if (row.status == 1) {
              row.status = 0;
            } else if (row.status == 0) {
              row.status = 1;
            }
          }
        },
      })
        .then((action) => {
          console.log("确定");
        })
        .catch(() => {
          console.log("取消");
        });
    },
    // 查询
    searchList() {
      this.listForm.pageNum=1;
      this.getPageList();
    },
    dialogBrandClose() {
      this.$nextTick(() => {
        this.editForm = {
          id: "",
          productBrandName: "", //名称
          productBrandCode: "", //编号
          productBrandQrCode: "",
        };
        this.$refs["editForm"].resetFields();
      });
    },
    // 搜索框重置
    reset() {
      this.$nextTick(() => {
        this.$refs["listForm"].resetFields();
        this.listForm = {
          pageNum: 1,
          pageSize: 10,
          status: null,
          productBrandName: "",
        };
        this.getPageList();
      });
    },
    handleCurrentChange(cpage) {
      this.listForm.pageNum = cpage;
      this.getPageList();
    },
    handleSizeChange(psize) {
      this.listForm.pageSize = psize;
      this.getPageList();
    },
  },
  mounted() {
    this.getPageList();
  },
};
</script>
<style lang="less" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  .title {
    padding: 0 50px;
    .search {
      float: right;
    }
  }
  .searchconditions {
    width: calc(100% - 30px);
    background: #fff;
    border-radius: 6px;
    margin-top: 10px;
    padding: 20px 15px;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
    .el-form {
      .el-form-item {
        display: inline-block;
        margin-right: 10px;
        vertical-align: top;
        margin: 5px 15px 5px 0px;
        /deep/.el-button {
          padding: 8px 15px;
          font-size: 12px;
          border-radius: 3px;
        }
      }
    }
  }
  .dialog-button {
    padding: 8px 15px;
    font-size: 12px;
    border-radius: 3px;
    margin-bottom: 15px;
  }
  .label-line {
    border-left: 3px solid #409eff;
    font-size: 16px;
    padding-left: 10px;
    font-weight: bold;
  }
  .avatar-uploader {
    /deep/.el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .el-upload:hover {
      border-color: #409eff;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 120px;
      height: 120px;
      line-height: 120px;
      text-align: center;
    }
    .avatar {
      width: 120px;
      height: 120px;
      display: block;
    }
  }
  .el-row {
    margin: 10px 0 0 !important ;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    background-color: #ffffff;
    padding: 5px 15px 0;
    .add-btn {
      float: left;
      padding: 0;
      margin-top: 5px;
      margin-bottom: 10px;
      .el-button {
        padding: 8px 15px;
        font-size: 12px;
        border-radius: 3px;
      }
    }
    .btn-group-right {
      float: right;
      .el-button {
        padding: 8px;
      }
    }
    .btn-group-right {
      margin-top: 5px;
      span {
        display: inline-block;
        vertical-align: top;
        font-size: 20px;
        padding: 8px;
      }
    }
    .standard-code {
      font-size: 14px;
      color: #8f8f8f;
      display: inline-block;
      line-height: 40px;
      margin-left: 10px;
    }
    .el-select {
      width: 100%;
    }
    .expiry-date /deep/.el-form-item__content {
      margin-left: 10px !important;
    }
  }
  /deep/.vue-treeselect__control {
    height: 40px;
    line-height: 40px;
  }
  /deep/.vue-treeselect__placeholder,
  /deep/.vue-treeselect__single-value {
    line-height: 40px;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/system/materialCenter/materialBrand.vue